export const camelCaseToSentanceCase = (text) => {
    var _a;
    if (!text) {
        return '';
    }
    const result = text === null || text === void 0 ? void 0 : text.replace(/([A-Z])/g, ' $1');
    let finalResult = ((_a = result === null || result === void 0 ? void 0 : result.charAt(0)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) + (result === null || result === void 0 ? void 0 : result.slice(1));
    if ((finalResult === null || finalResult === void 0 ? void 0 : finalResult.charAt(0)) === ' ') {
        finalResult = finalResult === null || finalResult === void 0 ? void 0 : finalResult.substring(1);
    }
    return finalResult;
};
export const capitalizeWords = (text) => {
    return text.replace(/(?:^|\s)\S/g, function (a) {
        return a.toUpperCase();
    });
};
export const capitalizeFirstLetter = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1);
};
export const getBase64FromBaseString = (dataFile) => {
    return dataFile ? dataFile.split('base64,')[1] : '';
};
export const getBase64TypeFromBaseString = (file) => { var _a; return file ? (_a = file === null || file === void 0 ? void 0 : file.split(';')[0]) === null || _a === void 0 ? void 0 : _a.split('/')[1] : ''; };
export const camelize = (text) => {
    return text
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
        .replace(/\s+/g, '');
};
export const ellipsisDescription = (text, limit) => {
    text = text !== null && text !== void 0 ? text : '';
    const returnText = text.length > limit ? text.slice(0, limit) + '...' : text;
    return returnText;
};
export const replaceBraces = (sentenceWithBraces, value) => {
    return sentenceWithBraces.replace(/\{(\w+)\}/g, () => {
        return value;
    });
};
export const toCamelCase = (str) => {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
    })
        .replace(/\s+/g, '')
        .replace(/[:\s]+/g, '')
        .replace(/[,\s]+/g, '')
        .replace(/[&\s]+/g, 'And');
};
export const getStringFromClassNameOrId = (data) => data.toString().split(/#|\./)[1];
export const parseBool = (str) => {
    return /^(true|1)$/i.test(str);
};
export function formatStringWithFirstLetterCapitalized(input) {
    const words = input.split('-');
    if (words.length > 0 && words[0].length > 0) {
        words[0] = words[0].charAt(0).toUpperCase() + words[0].slice(1);
    }
    const formattedString = words.join(' ');
    return formattedString;
}
export function formatTextToSlug(text) {
    return text.toLowerCase().replace(/\s+/g, '-');
}
export function addPhoneNumberMask(phoneNumber) {
    const part1 = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.slice(0, 3);
    const part2 = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.slice(3, 6);
    const part3 = phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.slice(6);
    return `${part1} ${part2} ${part3}`;
}
export function generateUniqueCode(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let uniqueCode = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        uniqueCode += characters[randomIndex];
    }
    return uniqueCode;
}
//# sourceMappingURL=text.utils.js.map